module.exports = __webpack_public_path__ + "static/media/logoFooter.6549ee27.png";